import React from 'react';
import { Grid, Segment } from 'semantic-ui-react';
import BottomPriceForm from './BottomPriceForm';
import DiscountSettingsForm from './DiscountSettingsForm';
import ExistingValueTable from './ExistingValue';
import DiscountSettingsBlacklistForm from './DiscountSettingsBlacklistForm';

function MainPage() {
  return (
    <>
      <Grid columns={2} padded>
        <Grid.Column width={10}>
          <div>
            <Segment.Group>
              <Segment>
                <h3>Discount Schemes</h3>
              </Segment>
              <Segment>
                <BottomPriceForm />
              </Segment>
              <Segment>
                <DiscountSettingsForm />
              </Segment>
            </Segment.Group>
            <DiscountSettingsBlacklistForm />
          </div>
        </Grid.Column>
        <Grid.Column width={6}>
          <ExistingValueTable />
        </Grid.Column>
      </Grid>
    </>
  );
}

export default MainPage;
